import { render } from "./CandleFormStep2.vue?vue&type=template&id=420617ad&scoped=true&lang=html"
import script from "./CandleFormStep2.vue?vue&type=script&lang=js"
export * from "./CandleFormStep2.vue?vue&type=script&lang=js"

import "./CandleFormStep2.vue?vue&type=style&index=0&id=420617ad&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420617ad"]])

export default __exports__